import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, mergeProps as _mergeProps, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-grey" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = { class: "mb-4 mt-8 text-grey" }
const _hoisted_8 = { class: "block w-full" }
const _hoisted_9 = { class: "grid grid-cols-1 gap-4 w-full" }
const _hoisted_10 = { class: "flex justify-end" }

import {Store} from "@bryntum/grid";
import {BryntumGrid} from "@bryntum/grid-vue-3";
import GridInputFilter from "@/components/system/GridInputFilter.vue";
import {onMounted, reactive, computed, ref} from "vue";
import {useI18n} from "vue-i18n";
import {PopupType, TableType} from "@/utilities/system/enums/Enums";
import {checkboxColumnConfig} from "@/AppConfig";
import {useProviderStore} from "@/stores/ProviderStore";
import {useSystemStore} from "@/stores/system/SystemStore";


export default /*#__PURE__*/_defineComponent({
  __name: 'SimilarProviderSelectionPopup',
  setup(__props) {

const gridStore = new Store();
const { t } = useI18n();
const systemStore = useSystemStore();
const providerStore = useProviderStore();

const currentSelectedProviderCompany = computed(()=>{
  return systemStore.modal.contentObject.selectedProviderCompany
});

const openEditWithEnteredCompanyData = ()=>{
  console.log("on on back", systemStore.modal.contentObject.suggestedProviderCompany)
  systemStore.openPopup({
    data:   systemStore.modal.contentObject.suggestedProviderCompany,
    action: providerStore.addOrUpdateProvider,
    resetButton: false,
    title:t("providerManagement.new"),
    type:PopupType.providerManagementEditPopup
  });
}

const grid = ref(null);
const useGridConfig = {
  headerMenuFeature: false,
  relayStoreEvents: true,
  autoHeight: true,
  columns : {
    data: [
      { id: 'name', field: 'name', text: t('providerManagement.grid.companyName'), flex: 1, },
      { id: 'address', field: 'address', text: t('providerManagement.grid.adress'), flex: 2, },
    ],
    listeners:{
      async add(event:any){
        if(event.records.length === 1 && event.isMove[event.records[0].id]){
          await systemStore.saveUserColumnOrder(TableType[TableType.similarCompany], event.records[0].id, event.index.toString());
        }
      },
    }
  },
  store: gridStore,
  enableTextSelection: true,
  selectionMode : {
    row	  : true,
    multiSelect: false,
    checkbox: checkboxColumnConfig,
    showCheckAll : true
  },
  listeners: {
    selectionChange(event) {
      const hasSelection = event.selection.length > 0 && event.selection[0]?.data !== undefined;
      systemStore.modal.contentObject.selectedProviderCompany = hasSelection
          ? event.selection.map(lr => lr.data)[0]
          : systemStore.modal.contentObject.suggestedProviderCompany;
    }
  },
}
const gridConfig = reactive(useGridConfig);

onMounted(()=> {
  gridStore.setStoreData(systemStore.modal.contentObject.similarCompanies);

  systemStore.reorderColumns(TableType[TableType.similarCompany], grid.value.instance.value.columns);
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h4", _hoisted_1, _toDisplayString(_ctx.$t("providerManagement.popups.selectedSimilarProvider.title")), 1),
    _createTextVNode(" " + _toDisplayString(currentSelectedProviderCompany.value.name), 1),
    _hoisted_2,
    _createTextVNode(" " + _toDisplayString(currentSelectedProviderCompany.value.street) + " " + _toDisplayString(currentSelectedProviderCompany.value.streetnumber), 1),
    _hoisted_3,
    _createTextVNode(" " + _toDisplayString(currentSelectedProviderCompany.value.zip) + " " + _toDisplayString(currentSelectedProviderCompany.value.city), 1),
    _hoisted_4,
    _createTextVNode(" " + _toDisplayString(currentSelectedProviderCompany.value.dialCode) + _toDisplayString(currentSelectedProviderCompany.value.phoneNumber), 1),
    _hoisted_5,
    _createElementVNode("button", {
      class: "btn mt-2",
      onClick: openEditWithEnteredCompanyData
    }, _toDisplayString(_ctx.$t("providerManagement.popups.selectedSimilarProvider.editInsertedData")), 1),
    _hoisted_6,
    _createElementVNode("h4", _hoisted_7, _toDisplayString(_ctx.$t("providerManagement.popups.selectedSimilarProvider.chooseAvailableProvider")), 1),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createVNode(GridInputFilter, {
            gridStore: _unref(gridStore),
            hideFilterButton: true
          }, null, 8, ["gridStore"])
        ]),
        _createVNode(_unref(BryntumGrid), _mergeProps({
          ref_key: "grid",
          ref: grid
        }, gridConfig, { readOnly: true }), null, 16)
      ])
    ])
  ]))
}
}

})